import { forwardRef } from "react";

import { Form } from "@shared/components/Form";
import { FormAutocompleteProps } from "@shared/components/Form/types";
import { getBookActivitiesService } from "@modules/bookActivities/services/queries/listBookActivities/service";

export const BookActivitiesAutocomplete = forwardRef<
  HTMLInputElement,
  Omit<FormAutocompleteProps, "options">
>((props, ref) => {
  return (
    <Form.Autocomplete
      {...props}
      ref={ref}
      queryHook={getBookActivitiesService}
    />
  );
});

BookActivitiesAutocomplete.displayName = "BookActivitiesAutocomplete";
